import React from "react";
import PropTypes from "prop-types";
import "./styles/Header.css";
import full_logo from './images/full_logo.png'

const Header = ({
  isSidebarDocked,
  handleOpenSidebar,
  isHeaderOptionsDisplayed,
  handleHeaderOptionsDisplayed,
  handleLogout
}) => {
  function renderSideBarIcon() {
    if (handleOpenSidebar) {
      return (
        !isSidebarDocked && (
          <span
            onClick={handleOpenSidebar.bind(null)}
            className="Header-sidebarIcon fa fa-reorder"
          />
        )
      );
    }
  }

  return (
    <div className="Header">
      {renderSideBarIcon()}
      <div className="Header--brand">
        <img src={full_logo} className="Header-logo" alt="brand" />
        <div>
          <p className="Header--bot-status">
            <i className="fa fa-circle" />ONLINE
          </p>
        </div>
      </div>
      <div className="Header--options">
        <i
          className="Header--options__ellipsis fa fa-ellipsis-v"
          onClick={handleHeaderOptionsDisplayed.bind(null)}
        />
        {isHeaderOptionsDisplayed && (
          <div
            onClick={handleHeaderOptionsDisplayed.bind(null)}
            className="Header--options__backdrop"
          >
            <ul className="Header--options__settings">
              <li className="Header--options__setting">
                <span className="fa fa-commenting" />
                <a
                  href="https://kudi.com/faq/fees/reporting-issues"
                  target="_blank"
                >
                  Contact Support
                </a>
              </li>
              <li
                className="Header--options__setting"
                onClick={handleLogout.bind(null)}
              >
                <span className="fa fa-cog" />Logout
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

Header.propTypes = {
  isHeaderOptionsDisplayed: PropTypes.bool,
  handleHeaderOptionsDisplayed: PropTypes.func,
  handleLogout: PropTypes.func
};

export default Header;



// WEBPACK FOOTER //
// ./src/modules/Header.js